<template>
  <v-btn
      color="primary"
      :loading="isLoading"
      :disabled="isDisabled"
      v-on="$listeners"
  >
    <v-icon left>{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CreateButton',
  props: {
    label: {
      type: String,
      default: 'Registrar',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'mdi-plus-box',
    },
  },
});
</script>